import { useState } from "react";
import { useTranslation } from "react-i18next";
import WarningIcon from "src/images/Icons/newIcons/warrning.svg";

import { TextBlackButton } from "../../../Default/LekUI/Button";
import ReportErrorInArticleModal from "../../Modals/ReportErrorInArticleModal";

function ContentActions(props) {
	const { t } = useTranslation();
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<div className="flex items-center justify-end">
			{isModalOpen && (
				<ReportErrorInArticleModal
					onClose={() => setIsModalOpen(false)}
					row={{
						...props.section,
						deprecatedArticleId: props.deprecatedArticleId,
					}}
				/>
			)}
			<TextBlackButton onClick={() => setIsModalOpen(true)}>
				<div className="flex gap-4 items-center justify-center">
					<WarningIcon className="icon-normal" />
					{t("modals.reportError.primary")}
				</div>
			</TextBlackButton>
		</div>
	);
}

export default ContentActions;
